<app-header>
  <div class="loader" *ngIf="loading">
    <mat-spinner style="margin:0 auto;"></mat-spinner>
  </div>
  <div class="card p-4" *ngIf="!loading">
    <div class="card-body" class="text-center">
      <h2 class="title text-primary">Activate Live Feed</h2>
      <p class="body-text mt-4">
        Enter the OTP to activate the required live feed on this device.<br>
        If the session is closed, a new OTP will need to be generated to reactivate the live feed (Reset OTP).
      </p>
      <div class="d-flex justify-content-center mt-4">
        <app-otp-input #input="ngModel" [(ngModel)]="otp" />
      </div>
      <button type="button" class="btn btn-primary btn-xl mt-4" (click)="submit()"
              [disabled]="input.invalid">Submit</button>
    </div>
  </div>
</app-header>